import React from "react";
import { Oval } from "react-loader-spinner";
import useDomainStore from "../../stores/domain";

function Spinner({ size = 80, color = "#4C70EF", secondaryColor = "#4C70EF" }) {
  const { isKurvDomain } = useDomainStore();
  
  // Use Kurv colors when on Kurv domain, otherwise use provided colors
  const finalColor = isKurvDomain ? "#22A276" : color;
  const finalSecondaryColor = isKurvDomain ? "#1B4F30" : secondaryColor;
  
  return (
    <div>
      <Oval
        visible={true}
        height={size}
        width={size}
        color={finalColor}
        secondaryColor={finalSecondaryColor}
        ariaLabel="loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
}

export default Spinner;
